import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import VaporDrawer from "../../../general/vapor/drawer";
import "./style.css";
import VaporContentSwitcherTab from "../../../vapor/contentSwitcherTab";
import { Button, Toggle } from "@ts-digital/vrc";
import { useDispatch, useSelector } from "react-redux";
import { deleteAssetGroup, getAsset, updatedAsset } from "../../../../store/actions/precog/assets";
import LoaderSimple from "../../../general/loader";
import SearchAssetsDrawerSection from "./searchAssetsDrawerSection";
import SelectedAssetsDrawerSection from "./selectedAssetsDrawerSection";
import AssignmentAndRevocationDrawerFields from "./assignmentAndRevocationDrawerFields";
import FringeBenefitDrawerFields from "./fringeBenefitDrawerFields";
import MovementsSection from "./movementsSection";
import ActivationDisactivationDrawerFields from "./activationDisactivationDrawerFields";
import DeducibilityDrawerFields from "./deducibilityDrawerFields";
import DepreciationDrawerFields from "./depreciationDrawerFields";
import FirstRegistryFieldsDrawerFields from "./firstRegistryFieldsDrawerFields";
import DrawerAccountsDetail from "./drawerAccounts/accountsDetail";

const renderTabs = (isListAssets) => {
  if (isListAssets)
    return [
      { value: "registry", label: <FormattedMessage id="preCog.assetsTab.drawer.registry" /> },
      { value: "depreciation", label: <FormattedMessage id="preCog.assetsTab.drawer.depreciation" /> },
      { value: "movements", label: <FormattedMessage id="preCog.assetsTab.drawer.movementsTitle" /> }
    ];
  return [
    { value: "registry", label: <FormattedMessage id="preCog.assetsTab.drawer.registry" /> },
    { value: "depreciation", label: <FormattedMessage id="preCog.assetsTab.drawer.depreciation" /> }
  ];
};

const AssetsDrawerDetail = (props) => {
  const { assetsDetails, businessId, isAssetGroup=false, onClose, visible, setIsUpdateTable = false,
    setCheckedAccount,
    getAssetInfo = true, showToggle = true, isListAssets = false } = props;

  const dispatch = useDispatch();
  const [drawerContentSwitch, setDrawerContentSwitch] = useState("registry");
  const [modifiedFields, setModifiedFields] = useState({});
  const [fieldsToDelete, setFieldsToDelete] = useState([]);
  const [editable, setEditable] = useState({});
  const [isDrawerAccountsDetail, setIsDrawerAccountsDetail] = useState(false);

  const [incrementExistingAsset, setIncrementAssetToggle] = useState(false);

  // Use state to manage search drawer
  const [assetSearched, setAssetSearched] = useState(null);
  const [isAssetSelected, setIsAssetSelected] = useState(false);

  // Use state to manage autosave timer
  const [autosaveTimer, setAutosaveTimer] = useState(null);
  const [minutesPassed, setMinutesPassed] = useState(null);

  const [disableSaveButton, setDisableSaveButton] = useState(false);

  // Manage visibility of common elements in drawer
  const [hideHeader, setHideHeader] = useState(false);

  // Manage visibility of fringe benefit section
  const [isFringeBenefitVisible, setIsFringeBenefitVisible] = useState(false);

  const isSellingInvoice = useSelector(state => state.precog?.invoiceDetail?.data?.doc?.active);
  
  useEffect(() => {
    
    if (getAssetInfo) {
      
      if (!assetsDetails) return;
      
      dispatch(getAsset(assetsDetails)).then(res => {
        setEditable({
          ...res,
          alias: res?.alias,
          newGood: res?.newGood === false ? "used" : "new",
          isReducedDeductibility: res.reducedDeductibility ? true : false,
          taxDepreciationRateType: res.taxDepreciationRateType ? res.taxDepreciationRateType : "ORDINARY",
          sellingDepreciation: res.sellingDepreciation,
          statutoryDepreciationType: res.statutoryDepreciationType ? res.statutoryDepreciationType : "TAX_CRITERIA",
          halfFirstYear: res.halfFirstYear
        });
        if (res.assetRegistryId) {
          setAssetSearched(res);
          setIsAssetSelected(true);
          setIncrementAssetToggle(true);
        }
      });
    } else {
      setEditable({
        ...assetsDetails,
        alias: assetsDetails?.alias,
        newGood: assetsDetails?.newGood === false ? "used" : "new",
        isReducedDeductibility: assetsDetails.reducedDeductibility ? true : false,
        taxDepreciationRateType: assetsDetails.taxDepreciationRateType ? assetsDetails.taxDepreciationRateType : "ORDINARY",
        sellingDepreciation: assetsDetails.sellingDepreciation,
        statutoryDepreciationType: assetsDetails.statutoryDepreciationType ? assetsDetails.statutoryDepreciationType : "TAX_CRITERIA",
        halfFirstYear: assetsDetails.halfFirstYear
      });
    }    
  }, [assetsDetails]);
  
  const activeSaveInterval = () => {
    if (autosaveTimer)
      clearInterval(autosaveTimer);
    setMinutesPassed(0);
    setAutosaveTimer(setInterval(() => {
      setMinutesPassed(minutesPassed + 1);
    }, 60000));
  };

  useEffect(() => {       
    // evita chiamata inutile alla patch se l'oggetto è vuoto
    if (Object.keys(modifiedFields).length === 0) return;

    let toSend = modifiedFields;
    if (toSend.newGood) {
      toSend.newGood = toSend.newGood === "new" ? true : false;
    }
    if (toSend.autosaveEnabled) {
      activeSaveInterval();
    }
    if (getAssetInfo) {
      if (isAssetSelected){
        
        dispatch(updatedAsset(assetSearched.uuid, toSend));
      } else {        
        dispatch(updatedAsset(assetsDetails, toSend));
      }
    } 
    // ATTENZIONE!!! TODO manca gestione update fixed assets
  }, [JSON.stringify(modifiedFields)]);

  useEffect(() => {    
    if (fieldsToDelete.length === 0) return;

    if (getAssetInfo) {
      if (isAssetSelected){
        dispatch(updatedAsset(assetSearched.uuid, { fieldsToDelete: fieldsToDelete }));
        setFieldsToDelete([]);
      } else {
        dispatch(updatedAsset(assetsDetails, { fieldsToDelete: fieldsToDelete }));
        setFieldsToDelete([]);
      }
    }
  }, [fieldsToDelete]);

  const renderContent = (kind = "registry") => {
    let items = [];
    switch (kind) {
    case "depreciation":
      items.push(<DepreciationDrawerFields key="DepreciationDrawerFields" editable={editable} setEditable={setEditable} setModifiedFields={setModifiedFields} modifiedFields={modifiedFields} setFieldsToDelete={setFieldsToDelete} />);
      break;
    default:
      items.push(<FirstRegistryFieldsDrawerFields 
        key="FirstRegistryFieldsDrawerFields" editable={editable} 
        parentId={visible?.parentId}
        setFieldsToDelete={setFieldsToDelete}
        isDrawerAccountsDetail={isDrawerAccountsDetail} setIsDrawerAccountsDetail={setIsDrawerAccountsDetail}
        setEditable={setEditable} setModifiedFields={setModifiedFields} modifiedFields={modifiedFields} />);
      break;
    }
    if (Object.keys(editable).length === 0) {
      return (<LoaderSimple message="Caricamento dati in corso. Si prega di attendere." />);
    } 
    if (kind === "registry") {
      items.push(<ActivationDisactivationDrawerFields key="ActivationDisactivationDrawerFields" editable={editable} setEditable={setEditable} setModifiedFields={setModifiedFields} modifiedFields={modifiedFields} setFieldsToDelete={setFieldsToDelete} />);

      items.push(<DeducibilityDrawerFields key="DeducibilityDrawerFields" editable={editable} setEditable={setEditable} setModifiedFields={setModifiedFields} modifiedFields={modifiedFields}/>);
      if ( editable.reducedDeductibility === "BUSINESS_VEHICLES" && editable.isReducedDeductibility)
        items.push(<AssignmentAndRevocationDrawerFields key="AssignmentAndRevocationDrawerFields" editable={editable} setEditable={setEditable} setModifiedFields={setModifiedFields} modifiedFields={modifiedFields} setDisableSaveButton={setDisableSaveButton} setIsFringeBenefitVisible={setIsFringeBenefitVisible} />);
      if (isListAssets && isFringeBenefitVisible) {
        items.push(<FringeBenefitDrawerFields key="FringeBenefitDrawerFields" editable={editable} setEditable={setEditable} setModifiedFields={setModifiedFields} modifiedFields={modifiedFields} setDisableSaveButton={setDisableSaveButton} />);
      }
    }
    
    return items;
    
  };

  const selectAsset = (asset) => {
    setAssetSearched(asset);
  };

  const handleButtonDrawer = () => {
    if (setCheckedAccount) setCheckedAccount(null);
    if ((!incrementExistingAsset && !isSellingInvoice) || isAssetSelected)
      onClose();
    else {
      if (assetSearched) {        
        dispatch(updatedAsset(assetsDetails, {
          assetRegistryId: assetSearched.id
        })).then(res=>{
          setIsAssetSelected(true);
          // ricaricare la tabella degli assets per recuperare il nuovo sottotipo
          setIsUpdateTable(true);          
        });
      }
    }
  };

  const renderFooterButton = () => {    
    return [
      <div key="footer" style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
      
        <div className="pre-cog-assets-drawer-footer-label">
          {isAssetGroup ? 
            <div 
              onClick={() => {            
                dispatch(deleteAssetGroup(assetsDetails)).then(el => onClose());
              }}
              style={{padding: "0 30px", color: "#0090d1", cursor: "pointer"}}>Annulla raggruppamento</div> : ""}
          <span style={{paddingLeft: "30px"}}>{minutesPassed !== null ? `Salvato ${minutesPassed} ${minutesPassed === 1 ? "minuto" : "minuti"} fa` : ""}</span>
        </div>
        {(!disableSaveButton && (incrementExistingAsset || isSellingInvoice) && !!assetSearched )  &&
        <Button kind="primary" onClick={() => { if (!disableSaveButton) handleButtonDrawer();} } disabled={disableSaveButton} style={{cursor: disableSaveButton ? "not-allowed" : "pointer"}}>
          {(!incrementExistingAsset && !isSellingInvoice) || isAssetSelected
            ? <FormattedMessage id="preCog.saveAndClose" /> 
            : <FormattedMessage id="preCog.assetsTab.confirm" />}
        </Button>
        }
        {(!disableSaveButton && (!incrementExistingAsset && !isSellingInvoice) && !isAssetSelected )  &&
        <Button kind="primary" onClick={() => { if (!disableSaveButton) handleButtonDrawer();} } disabled={disableSaveButton} style={{cursor: disableSaveButton ? "not-allowed" : "pointer"}}>          
          <FormattedMessage id="preCog.saveAndClose" />            
        </Button>
        }
      </div>
    ];
  };
  const [bottomButtons, setBottomButtons] = React.useState(renderFooterButton());
  useEffect(()=>{
    setBottomButtons(renderFooterButton());
  },[minutesPassed, incrementExistingAsset, isSellingInvoice, isAssetSelected, assetSearched]);
  
  return (
    <>
      <VaporDrawer
        onClose={onClose}
        visible={visible}
        title={
          <div
            className="dbx-preCog-intrastat-add-nomenclatura-title"
            style={{ width: 700 }}
          >
            <FormattedMessage id="preCog.assetsTab.assetsData" />
          </div>
        }
        width={800}
        maskClosable={false}
        buttons={bottomButtons}
        hideFooter={!bottomButtons || bottomButtons.length === 0}
      >
        <div className="precog-withholding-drawer-root">
          {!hideHeader && <div className="drawer-header">
            <VaporContentSwitcherTab
              selected={drawerContentSwitch}
              itemsWidth={140}
              onChange={val => setDrawerContentSwitch(val)}
              items={(!incrementExistingAsset && !isSellingInvoice) || isAssetSelected ? renderTabs(isListAssets) : []}
            />
          </div>}
          <div className="pre-cog-assets-drawer-content-items">
            <div className="drawer-toggle">
              {!isAssetSelected && !isSellingInvoice && showToggle && drawerContentSwitch !== "depreciation" &&
              <React.Fragment>
                <Toggle
                  onChange={() => {
                    setIncrementAssetToggle(!incrementExistingAsset);                    
                    setDisableSaveButton(!incrementExistingAsset);                    
                  }}
                  checked={incrementExistingAsset}
                />
                <div className="drawer-text">
                  <FormattedMessage id={"preCog.assetsTab.drawer.incrementExistingAsset"} />
                </div>
              </React.Fragment>}
            </div>           
            {(!incrementExistingAsset && !isSellingInvoice && drawerContentSwitch !== "movements") && 
          renderContent(drawerContentSwitch)}
            {((!incrementExistingAsset && !isSellingInvoice && drawerContentSwitch === "movements")) && 
              <MovementsSection setHideHeader={setHideHeader} setBottomButtons={setBottomButtons} assetsDetails={assetsDetails} />}
            {((incrementExistingAsset && !isAssetSelected) || (isSellingInvoice && !isAssetSelected)) && 
              <SearchAssetsDrawerSection businessId={businessId} setDisableSaveButton={setDisableSaveButton} selectAsset={selectAsset} isSellingInvoice={isSellingInvoice} />}
            {isAssetSelected && drawerContentSwitch !== "depreciation" && 
            <SelectedAssetsDrawerSection businessId={businessId} asset={assetSearched} isSellingInvoice={isSellingInvoice} assetsDetails={assetsDetails} setIsAssetSelected={setIsAssetSelected} activeSaveInterval={activeSaveInterval} setFieldsToDelete={setFieldsToDelete}
              setIsDrawerAccountsDetail={setIsDrawerAccountsDetail} setAssetSearched={setAssetSearched} setDisableSaveButton={setDisableSaveButton} />}
            {isAssetSelected && drawerContentSwitch === "depreciation" && renderContent(drawerContentSwitch)}
          </div>
        </div>      
      </VaporDrawer >
      {/** Dettaglio conti contabili drawer */}
      <DrawerAccountsDetail
        isDrawerOpen={isDrawerAccountsDetail} 
        setIsDrawerOpen={setIsDrawerAccountsDetail} 
        title={editable.accountDesc}
        accountCode={editable.accountCode}
      />
    </>
  );
};

export default AssetsDrawerDetail;
